"use client"
import React from 'react'
import Navbar from '../../components/agent/common/Navbar';
import MainApplication from "../../components/agent/lead/Application/MainApplication"
const AgentApplications = () => {

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="p-4 md:p-8">
       <MainApplication/>
      </main>
    </div>
  )
}

export default AgentApplications
